import { mapRange } from '@wix/wow-utils';
import {
  AnimationProperties,
  AnimationsKit,
  MouseAnimationInstance,
  MouseParams,
} from '../../../types';
import { getMouseTransitionEasing } from '../../../utils/animationsUtils';

export interface Params extends MouseParams {
  inverted?: boolean;
  angle?: number;
  perspective?: number;
  pivotAxis?: keyof typeof transformOrigins;
}

const transformOrigins = {
  top: [0, -50],
  bottom: [0, 50],
  right: [50, 0],
  left: [-50, 0],
  'center-horizontal': [0, 0],
  'center-vertical': [0, 0],
} as const;

export const name = 'SwivelMouse';
export const properties: AnimationProperties = {
  schema: {},
};

export function animate(
  _kit: AnimationsKit,
  elements: HTMLElement[],
  _duration: number,
  _delay: number,
  {
    inverted = false,
    angle = 5,
    perspective = 800,
    pivotAxis = 'center-horizontal',
    transitionDuration,
    transitionEasing = 'linear',
  }: Params = {},
): MouseAnimationInstance {
  const element = elements[0];
  const invert = inverted ? -1 : 1;

  if (transitionDuration) {
    element.style.transition = `transform ${transitionDuration}ms ${getMouseTransitionEasing(
      transitionEasing,
    )}`;
  }

  return {
    progress({ x: progressX, y: progressY }) {
      let rotateAxis = 'rotateX';
      let progress = progressY;
      let invertVertical = -1;

      if (
        pivotAxis === 'center-horizontal' ||
        pivotAxis === 'right' ||
        pivotAxis === 'left'
      ) {
        rotateAxis = 'rotateY';
        progress = progressX;
        invertVertical = 1;
      }

      // if progress  === 0, rotate === angle, if progress === 0.5, rotate === 0, if progress === 1, rotate === angle
      const rotate =
        mapRange(0, 1, -angle, angle, progress) * invertVertical * invert;

      const [translateX, translateY] = transformOrigins[pivotAxis];
      const transform = `perspective(${perspective}px) translateX(${translateX}%) translateY(${translateY}%) ${rotateAxis}(${rotate}deg) translateX(${-translateX}%) translateY(${-translateY}%) rotate(var(--comp-rotate-z, 0deg))`;

      element.style.transform = transform;
    },

    kill() {
      element.style.transform = '';
      element.style.transition = '';
    },
  };
}
